export const NO_IMAGE_URL =
  "https://blueberrydatastorage.blob.core.windows.net/websitesdata/NH/noimage.jpg";

function asList(value) {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.data)) return value.data;
  return [];
}

function getImagePath(item) {
  return String(item?.imagePath || item?.path || "").trim();
}

function mapImages(list, category) {
  return asList(list)
    .map((item, index) => {
      const src = getImagePath(item);
      if (!src) return null;
      return {
        id: `${category}-${index}-${src}`,
        src,
        alt: item.alternateText || item.alternatetext || "",
        category,
      };
    })
    .filter(Boolean);
}

function uniqueBySrc(images = []) {
  const seen = new Set();
  return images.filter((image) => {
    if (seen.has(image.src)) return false;
    seen.add(image.src);
    return true;
  });
}

function mapReviewImages(list) {
  return asList(list)
    .map((item, index) => {
      const src =
        typeof item === "string"
          ? item.trim()
          : getImagePath(item);
      if (!src) return null;
      return {
        id: `clientReview-${index}-${src}`,
        src,
        alt: item?.alternateText || item?.alternatetext || "Client review",
        category: "clientReview",
      };
    })
    .filter(Boolean);
}

export function buildPackageGalleryData({
  packageImages = [],
  activityImages = [],
  groupedHotels = [],
  reviewImages = [],
  banner = "",
  thumb = "",
}) {
  const activity = mapImages(activityImages, "activity");
  const property = (groupedHotels || []).flatMap((cityGroup) =>
    (cityGroup.hotels || []).flatMap((hotel) => mapImages(hotel.images, "property"))
  );
  const packageExtra = mapImages(
    asList(packageImages).filter((item) => !/banner|thumb/i.test(item.imageType || "")),
    "all"
  );
  const clientReviewImages = mapReviewImages(reviewImages);

  let all = uniqueBySrc([
    ...activity,
    ...property,
    ...packageExtra,
    ...clientReviewImages,
  ]);

  if (banner && !all.some((item) => item.src === banner)) {
    all = [{ id: `banner-${banner}`, src: banner, alt: "", category: "all" }, ...all];
  }

  if (!all.length && thumb) {
    all = [{ id: `thumb-${thumb}`, src: thumb, alt: "", category: "all" }];
  }

  const fallback = banner || thumb || all[0]?.src || NO_IMAGE_URL;

  return {
    categories: {
      all,
      activity,
      property,
      clientReview: clientReviewImages,
    },
    counts: {
      all: all.length,
      activity: activity.length,
      property: property.length,
      clientReview: clientReviewImages.length,
    },
    previewTiles: {
      sightseeing: activity[0]?.src || NO_IMAGE_URL,
      clientReview: clientReviewImages[0]?.src || NO_IMAGE_URL,
      main: fallback,
      property: property[0]?.src || NO_IMAGE_URL,
      activities: activity[1]?.src || activity[0]?.src || NO_IMAGE_URL,
    },
  };
}

export function getGalleryCategoryImages(categories, categoryId = "all") {
  return categories?.[categoryId] || categories?.all || [];
}

export function findGalleryImageIndex(images, src) {
  if (!src) return 0;
  const index = images.findIndex((item) => item.src === src);
  return index >= 0 ? index : 0;
}
